import { render, staticRenderFns } from "./Snapshot.vue?vue&type=template&id=79c229c5&scoped=true"
import script from "./Snapshot.vue?vue&type=script&lang=js"
export * from "./Snapshot.vue?vue&type=script&lang=js"
import style0 from "./Snapshot.vue?vue&type=style&index=0&id=79c229c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c229c5",
  null
  
)

export default component.exports